export class MealTagModel {
    id: number;
    name: string;
    display: boolean;

    constructor() {
        this.id = 0;
        this.name = '';
        this.display = true;
    }

}